var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountBlockImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 128,
    viewBox: "0 0 130 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.8499 96.6344L32.4396 65.8466V35.1761L64.8499 65.8798L129.588 4.53223V35.2359L64.8499 96.6344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.8499 96.6355L32.4396 65.8477V35.1772L64.8499 65.8809V96.6355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M65.429 35.3226V4.68661L97.941 -26V4.68661L65.429 35.3226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M0.325897 187.347V156.931L64.8688 96.2585V126.624L0.325897 187.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 127.095V96.4586L32.512 65.772V96.4586L0 127.095Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2614 187.29L64.8511 156.841V126.508L97.2614 156.874L162 96.2012V126.567L97.2614 187.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6546 126.471V95.8346L130.265 65.1479V95.8346L97.6546 126.471Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountBlockImage);
export default __webpack_public_path__ + "static/media/CountBlock_image.63f8cb0e1dfeffc92119d782a4fe9aa7.svg";
export { ForwardRef as ReactComponent };